import { render, staticRenderFns } from "./submitApplyReturn.vue?vue&type=template&id=2e1ebb7d&scoped=true&"
import script from "./submitApplyReturn.vue?vue&type=script&lang=js&"
export * from "./submitApplyReturn.vue?vue&type=script&lang=js&"
import style0 from "./submitApplyReturn.vue?vue&type=style&index=0&id=2e1ebb7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1ebb7d",
  null
  
)

export default component.exports